/* eslint-disable no-unused-vars */
import { memo, useCallback, useMemo } from 'react';
import { useComputed, useSignalEffect, useSignal } from '@preact/signals-react';
import { useSelector } from 'react-redux';
import * as S from './ListParams.styled';

const isValidField = {
  Deep_Link: 'deeplink',
  Impression_Link: 'impression',
  Tracking_Link: 'tracking',
  VTA_Link: 'vta',
};

const extraIsValidField = {
  Deep_Link: 'tracking',
  Impression_Link: 'vta',
  Tracking_Link: 'deeplink',
  VTA_Link: 'impression',
};

const validator_domains_field = {
  Tracking_Link: 'tracking_domains',
  VTA_Link: 'vta_domains',
  Deep_Link: 'deeplink_domains',
  Impression_Link: 'impression_domains',
};

const extra_validator_domains_field = {
  Tracking_Link: 'deeplink_domains',
  VTA_Link: 'impression_domains',
  Deep_Link: 'tracking_domains',
  Impression_Link: 'vta_domains',
};

const ListParams = ({ cleanData$, name }) => {
  const linkValidator = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.link_validator_data,
  );

  const getCurrentDomain = useCallback(() => {
    try {
      const url = new URL(cleanData$.value);
      return url.host;
    } catch (err) {
      return null;
    }
  }, [cleanData$.value]);

  // --------------------------------------
  // useMemo: currentLinkValidator
  // --------------------------------------
  // מחשב את ה-validator שמתאים לדומיין הנוכחי
  const currentLinkValidator = useMemo(() => {
    const currentDomain = getCurrentDomain();

    if (currentDomain && linkValidator?.length > 0) {
      return linkValidator.find((item) => {
        let domainsArr =
          item[validator_domains_field[name]] === null
            ? item[extra_validator_domains_field[name]]
            : item[validator_domains_field[name]];
        domainsArr = domainsArr?.map((domain) => domain.tc_domain_name);
        return domainsArr?.some((domain) => currentDomain.includes(domain));
      });
    }
    return null;
  }, [cleanData$.value, linkValidator, name]);

  const validParams = useMemo(() => {
    if (currentLinkValidator) {
      const paramsArr =
        currentLinkValidator[validator_domains_field[name]] !== null
          ? currentLinkValidator[`${isValidField[name]}_params_android`]
          : currentLinkValidator[`${extraIsValidField[name]}_params_android`];
      return paramsArr?.filter((item) => item.show_in_list);
    } else return null;
  }, [cleanData$.value, currentLinkValidator, name]); // dependencies עודכנו בהתאם

  const optionParams = validParams
    ?.filter((item) => !item.tcp_is_mandatory)
    ?.map((item) => item.param_values?.find(({ tcp_version }) => tcp_version === 1));

  const mandatoryParams = validParams
    ?.filter((item) => item.tcp_is_mandatory)
    ?.map((item) => item.param_values?.find(({ tcp_version }) => tcp_version === 1));

  return (
    <>
      {validParams !== null && (
        <>
          <S.Container>
            {mandatoryParams?.length > 0 ? (
              <S.MacrosList>
                <S.Title>Mandatory macros:</S.Title>
                {mandatoryParams?.map((item, i) => {
                  return (
                    <S.Macros key={i}>
                      <S.Text>{item.tcp_param_display_text} </S.Text>
                      <S.Description>{item.tcp_description}</S.Description>
                    </S.Macros>
                  );
                })}
              </S.MacrosList>
            ) : null}

            {optionParams?.length > 0 ? (
              <S.MacrosList>
                <S.Title>Optional macros:</S.Title>
                {optionParams?.map((item, i) => {
                  return (
                    <S.Macros key={i}>
                      <S.Text>{item.tcp_param_display_text} </S.Text>
                      <S.Description>{item.tcp_description}</S.Description>
                    </S.Macros>
                  );
                })}
              </S.MacrosList>
            ) : null}
          </S.Container>
          <S.FoterStr>
            For additional macros please click
            <a
              href='https://wiki.appnext.com/hc/en-us/articles/4404347716114-Appnext-Macros'
              target='_blank'
              rel='noreferrer'
            >
              here.
            </a>
          </S.FoterStr>
        </>
      )}
    </>
  );
};

export default memo(ListParams);
//https://redirect.appmetrica.yandex.com/serve/TRACKING_ID?click_id=xapnt1x&google_aid=xapnt6x&device_ip=xapnt5x&device_ua={apnt_httpuseragent}&click_timestamp={apnt_clicktimestamp}&afpub_id=xapnt17x&site_id=xapnt20x&creative_id={apnt_crtname}&c_id={apnt_campid}&c_name={apnt_campname}&pub_appname=xapnt21x&package={apnt_anpackage}{apnt_iosid}
